export default __webpack_public_path__ + "likeometer.88ded.svg";